"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const backgroundRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537494/img/image_ww8nmxz3.png)] py-12 md:py-0 !bg-[url(https://markjohnstonmotors.ie/wp-content/uploads/2026/02/Untitled-design-8.png)] !bg-[url(https://markjohnstonmotors.ie/wp-content/uploads/2026/02/Untitled-design-8.png)]">
      {}
      <div ref={backgroundRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537494/img/image_ww8nmxz3.png)] animate-[ken-burns_10s_ease-out_infinite_alternate]" style={{
      filter: "blur(2px)"
    }} />

      {}
      <div className="absolute inset-0 bg-black/30" />

      {}
      <div className="container relative z-10 text-center px-4 sm:px-6 md:px-8">
        <div className={`transition-all duration-[600ms] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h1 className="font-display text-[48px] sm:text-[56px] md:text-[64px] lg:text-[72px] font-bold leading-[1.1] text-white mb-6 drop-shadow-[0_4px_12px_rgba(0,0,0,0.3)]">
            Expert Care for Your Vehicle
          </h1>

          <p className="text-[20px] sm:text-[22px] md:text-[24px] text-white/90 font-sans max-w-[600px] mx-auto mb-10 drop-shadow-[0_2px_8px_rgba(0,0,0,0.2)]">
            Professional servicing, diagnostics, and NCT repairs across three convenient Wicklow locations
          </p>

          <Link to="#services">
            <Button size="lg" className="btn-primary text-[18px] sm:text-[20px] md:text-[22px] px-6 sm:px-8 md:px-10 py-6 h-auto shadow-strong">Book Service</Button>
          </Link>
        </div>
      </div>

      <style jsx>{`
        @keyframes ken-burns {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.1);
          }
        }
      `}</style>
    </section>;
}